exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ctn {\n  display: inline-block;\n  min-width: 250px;\n  width: 250px; }\n  .ctn table tbody tr {\n    background: #F6F9FE !important; }\n    .ctn table tbody tr.active {\n      background: #DBDEE2 !important; }\n  .ctn td {\n    border-top: 1px solid #ccc;\n    padding: 0.25rem; }\n  .ctn table tbody tr:first-child td {\n    border-top: 0; }\n\n.table.br thead.thead-inverse th {\n  background: #6e8d9b; }\n\n.table.br thead th:first-child,\n.table.br tr td:first-child {\n  padding-left: 20px !important; }\n\n.table.br .break {\n  font-size: 0.9rem;\n  color: #000; }\n\n.tbl-header {\n  height: 40px;\n  max-height: 40px;\n  overflow: hidden;\n  background: #5f7b88; }\n\ntable.mb-0 {\n  height: 45px;\n  max-height: 45px;\n  overflow: hidden; }\n\n.h46 {\n  height: 46px;\n  max-height: 46px;\n  min-height: 46px;\n  overflow: hidden;\n  line-height: 1.1rem;\n  vertical-align: middle;\n  display: table-cell; }\n  .h46 :first-child {\n    border-top: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/data-cards/data-card-tbl/data-card-tbl.component.scss
// module id = ../../../../../src/app/brds/widgets/data-cards/data-card-tbl/data-card-tbl.component.scss
// module chunks = 10